import Vue from 'vue'
import store from './store/index'
import App from './App.vue'
import VCharts from 'v-charts'
import VueAwesomeSwiper from "vue-awesome-swiper"
import createApp from '@shopify/app-bridge';
import { isShopifyEmbedded } from '@shopify/app-bridge-utils';
import localStorage from '@/api/storage.js'
import { sessionRead } from '@/utils/util'

import "swiper/css/swiper.css"

Vue.use(VueAwesomeSwiper)
Vue.use(VCharts)
Vue.prototype.$local = localStorage;
Vue.use(localStorage);

import router from "@/router"

// 引入 Ant Design
// import Antd from 'ant-design-vue/es'
import 'ant-design-vue/dist/antd.css'

//引入 polaris 组件 暂不去掉
import PolarisVue from '@eastsideco/polaris-vue'
//引入 polaris 样式
// import '@eastsideco/polaris-vue/lib/polaris-vue.css'
// import '@eastsideco/polaris-vue/lib/styles.css'

//引入公共样式
import './assets/css/common.css'
import './assets/css/helper.css'
import './assets/css/styles6.3.0.css'

//引入animate.css
import animated from "animate.css"

import Snackbar from "@/components/snackbar/snackbar";
import "@/components/snackbar/snackbar.css";

// Vue.use(Antd)
Vue.use(PolarisVue)
Vue.use(store)

//使用animated.css
Vue.use(animated)

Vue.prototype.$Snackbar = Snackbar;

Vue.config.productionTip = false;
Vue.config.silent = true;


// 初始化 app Bridge
if (isShopifyEmbedded()) {
  window.addEventListener("message",
    function (e) {
      if (e.data.payload != undefined && e.data.payload.type === "APP::CLIENT::INITIALIZE") {
        if (store.state.shopifyAppObj === null) {
          var shopifyApp = createApp({
            apiKey: process.env.VUE_APP_API_KEY,
            host: sessionRead("host")
          });
          store.commit("setShopifyAppObj", shopifyApp);
        }
      }

    }, false);
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
